import { useGetAnalysisInvestmentStates } from "Infrastructure/ApiZfp/AnalyzerApi";
import { NsureClientCaseStateCaseStatus } from "Infrastructure/ApiZfp/Schema";

export const useLockedInvestmentCaseStatus = (analysisId: string, versionId: string) => {
  const {
    data: investmentStates,
    isPending: isInvestmentStatesPending,
    isFetched: isInvestmentStatesFetched,
    isError: isInvestmentStatesError,
  } = useGetAnalysisInvestmentStates(analysisId, versionId);

  const lockedCaseStatus =
    investmentStates?.find(
      (s) =>
        s.caseStatus != null &&
        s.caseStatus !== NsureClientCaseStateCaseStatus.New &&
        s.caseStatus !== NsureClientCaseStateCaseStatus.InProgress,
    )?.caseStatus ?? null;

  const isInvestmentCaseLocked = lockedCaseStatus !== null;

  return {
    lockedCaseStatus,
    isInvestmentCaseLocked,
    isInvestmentStatesPending,
    isInvestmentStatesFetched,
    isInvestmentStatesError,
  };
};
